import { render, staticRenderFns } from "./OtherOfficeConnectionTable.vue?vue&type=template&id=180b7ee8&scoped=true&lang=pug"
import script from "./OtherOfficeConnectionTable.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeConnectionTable.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeConnectionTable.vue?vue&type=style&index=0&id=180b7ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b7ee8",
  null
  
)

export default component.exports